import React from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { dashboardAPI } from '../services/api';

// Searchable employee select, shared by any page that needs an
// "apply this to one specific employee" scope (Productivity Rating,
// App Blocking). Debounced search against GET /api/web/employees.
export default function EmployeePicker({ value, onChange, size = 'small', sx }) {
    const [options, setOptions] = React.useState([]);
    const [inputValue, setInputValue] = React.useState('');
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        let cancelled = false;
        setLoading(true);
        const handle = setTimeout(() => {
            dashboardAPI.getEmployees({ search: inputValue || undefined })
                .then((res) => { if (!cancelled && res.data.error !== '1') setOptions(res.data.employees || []); })
                .catch(() => {})
                .finally(() => { if (!cancelled) setLoading(false); });
        }, 300);
        return () => { cancelled = true; clearTimeout(handle); };
    }, [inputValue]);

    return (
        <Autocomplete
            size={size}
            sx={sx}
            options={options}
            value={value}
            onChange={(_, v) => onChange(v)}
            onInputChange={(_, v) => setInputValue(v)}
            getOptionLabel={(o) => o?.name ? `${o.name} (${o.employee_id})` : ''}
            isOptionEqualToValue={(o, v) => o.user_id === v?.user_id}
            loading={loading}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Employee"
                    placeholder="Search employees…"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress size={16} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
}
